import { useIntl } from '@/intl'

import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'

import {
  Button,
  Icon,
  Sheet,
  SheetClose,
  SheetContent,
  SheetContentWrapper,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
  SheetTitle,
  space,
  SpaceBetween,
  tk,
  Typography,
} from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

const ExplanationTitle = styled(Typography)`
  font-size: 20px;
`

const Explanation = styled(Typography)`
  font-size: ${tk('font_size_md')};
`

const StyledSheetContent = styled(SheetContentWrapper)`
  padding: ${tk('spacing_lg')};
`

const InfoButton = styled(Button)`
  position: relative;
`

export function SortingExplanationLegacy({ className }: { className?: string }) {
  const intl = useIntl()
  const [isActive, setIsActive] = React.useState(false)
  const { isMobile } = useBreakpoints()

  const handleModalClose = () => {
    setIsActive(false)
  }

  const toggle = () => {
    setIsActive(!isActive)
  }

  return (
    <div className={className}>
      <InfoButton $withoutColor $hierarchy="tertiary" onClick={toggle}>
        <Icon glyph="IconInformationCircle" size="sm" />
      </InfoButton>
      <Sheet open={isActive} onOpenChange={handleModalClose}>
        <SheetPortal>
          <SheetOverlay onClick={() => handleModalClose} />
          <SheetContent $side={isMobile ? 'right' : 'bottom'}>
            <SheetHeader>
              <SheetTitle>{intl.formatMessage({ id: 'sort_info_title' })}</SheetTitle>
              <SheetClose>{intl.formatMessage({ id: 'close' })}</SheetClose>
            </SheetHeader>
            <StyledSheetContent>
              <SpaceBetween direction="y" spacing={space('primitives_space_12')}>
                <ExplanationTitle $variant="body-lg-bold">
                  {intl.formatMessage({ id: 'sort_info_popularity_title' })}
                </ExplanationTitle>
                <Explanation>
                  {intl.formatMessage({
                    id: 'sort_info_popularity_description',
                  })}
                </Explanation>
              </SpaceBetween>
            </StyledSheetContent>
          </SheetContent>
        </SheetPortal>
      </Sheet>
    </div>
  )
}
